export const abbreviateDay = str => {
  return str[0].toUpperCase() + str.slice(1, 3);
};



// WEBPACK FOOTER //
// ./src/utils/abbreviateDay.js